import { sendToAnalytics, setAnalyticsPeopleProperty } from '../../Analytics'
import { getAuthenticatedUsername } from '../../stores/useBootstrapStore'

/**
 * One event name for the whole guide, verb in `action` — the repo's
 * convention for multi-step features. Mixpanel is the platform of record
 * (its distinct_id is the username, so this joins to signup); PostHog is
 * mirrored separately because sendToAnalytics never touches it.
 */
export const trackOnboarding = (action, data = {}) => {
    const payload = { action, ...data }
    // Called from inside the store's advanceTo — a throwing analytics sink
    // must not abort the stage advance.
    try {
        sendToAnalytics({
            userId: getAuthenticatedUsername(),
            event: 'onboarding_action',
            data: payload,
        })
        window.posthog?.capture?.('onboarding_action', payload)
    } catch (ignored) {}
}

/**
 * The one irreplaceable marker: nothing else distinguishes a user who saw
 * the guide from one who signed up the same week and wasn't eligible. Every
 * derived metric filters on it.
 */
export const markGuidedUser = () => {
    setAnalyticsPeopleProperty({ onboarding_guide: true })
    try {
        window.posthog?.setPersonProperties?.({ onboarding_guide: true })
    } catch (ignored) {}
}

/**
 * Which persona's flow the guided user walked, so every funnel above can be
 * split by it. Distinct from the profile's `persona` (PersonaToast): that one
 * is the self-report; this one says the guide branched on it.
 */
export const markPersona = persona => {
    const properties = { onboarding_persona: persona || 'none' }
    setAnalyticsPeopleProperty(properties)
    try {
        window.posthog?.setPersonProperties?.(properties)
    } catch (ignored) {}
}
